import React from 'react';
import Config from '../../../../../../Config';
import './Legal.css';

export const Legal = () => {
    return (
        <div className="ps-legal">
            <a className="ps-copyright" href="http://www.pavasal.com" target={'_blank'}>&copy; 2017 Pavasal</a>
            <span className="ps-version">v{Config.VERSION}</span>
        </div>
    );
};

Legal.propTypes = {};

Legal.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/sidebar/legal/Legal.jsx